import styled from 'styled-components';

import ButtonSecondary from '@components/ButtonSecondary';
import {
  p, pb, pt, px
} from 'styled-components-spacing';

import theme from '@theme';

export const { borderRadius, shadows, colors } = theme;

export const StyledCover = styled.a`
  ${borderRadius.medium}
  ${shadows.medium}

  min-height: 200px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  cursor: pointer;
  text-decoration: none;
`;

export const StyledHeadlineText = styled.div`
  ${pt(3.5)}
  ${pb(3.5)}
  ${px(3)}

  font-size: 18px;
  font-weight: 600;
  color: ${colors.darkBlue};
  text-align: center;
  line-height: 24px;
`;

export const StyledSubline = styled.div`
  ${pb(3.5)}
  ${px(3)}

  font-size: 14px;
  color: ${colors.translucentDarkBlue};
  text-align: center;
  text-transform: uppercase;

  margin-top: auto;
`;

export const StyledInfo = styled.div`
  ${pb(3.5)}
  ${px(3)}

  font-size: 14px;
  color: ${colors.darkBlue};
  text-align: center;
`;

export const StyledButtonSecondary = styled(ButtonSecondary)`
  color: ${colors.defaultGreen};
  border-color: ${colors.defaultGreen};
  &:focus {
    outline: none;
  }
`;

export const StyledContentTop = styled.div`
  flex: 1 0 auto;

  display: flex;
  flex-direction: column;
`;

export const StyledContentBottom = styled.div`
  ${p(3)}
  ${pt(0)}

  flex: 0 1 auto;
`;
